// @flow

const initialState = {
    adDetail:{},
    isLoading:false,
    data:{},
    paymentHash:"",
    selectedQuantity:1,
    MRP:0,
    retailPrice : 0,
    displayRewards:0,
    // quantityLimit:1,
};

export default function detail(state= initialState, action:any) {
    switch (action.type) {
        case 'GET_DETAIL_OF_AD_FULFILLED':
            return {
                ...state,
                displayRewards:action.payload.data.adDetails.RewardDisplay,
                paymentHash:action.payload.data.PaymentHash,selectedQuantity:1,                                                                                                                                                                                                                                                                            
                adDetail:action.payload.data.adDetails,
                MRP:action.payload.data.adDetails.MRP,
                retailPrice : action.payload.data.adDetails.RetailPrice,isLoading:false};
        case 'GET_DETAIL_OF_AD_REJECTED':
            return {...state, adDetail:{},isLoading:false};
        case 'GET_DETAIL_OF_AD_PENDING':
            return {...state, adDetail:{},isLoading:true};    
        case 'ADD_TO_CART_FULFILLED':
            return {...state,data:action.payload,isLoading:false};
        case 'ADD_TO_CART_AD_REJECTED':
            return {...state, isLoading:false};
        case 'ADD_TO_CART_AD_PENDING':
            return {...state,isLoading:true};  

        case 'INCREASE_QUANTITY_PRODUCT':
            var selectedQuantity = parseInt(action.payload);
            if(action.payload < state.adDetail.QuantityLimit){
                return {...state,selectedQuantity:selectedQuantity+1,
                    MRP:state.MRP+state.adDetail.MRP,
                    displayRewards:state.displayRewards+state.adDetail.Reward,
                    retailPrice:state.retailPrice+state.adDetail.RetailPrice };   
            }
        case 'DECREASE_QUANTITY_PRODUCT':
            var selectedQuantity = parseInt(action.payload)
            if(action.payload > 1){
                return {...state,selectedQuantity:selectedQuantity-1,
                    MRP:state.MRP-state.adDetail.MRP,
                    displayRewards:state.displayRewards-state.adDetail.Reward,
                    retailPrice:state.retailPrice-state.adDetail.RetailPrice};   
            }   
        case 'LOG_OUT':
            return state;
        default:
            return state;
    }
}
